import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PopupModel, PopupButton, EmailPopupModel, PopupModelReturn, PopupSetupModel } from '../AllTableClasses';

@Injectable({
  providedIn: 'root'
})
export class PopupNotificationService {

  CloseAllPopups() {
    this.CloseServicePopup();
    this.ClosePatientPopup();
    this.CloseEmailPopup();
    this.CloseStaffPopup();
    this.CloseAppointmentPopup();
    this.CloseCheckoutPopup();
    this.CloseAdministrationPopup();
    this.CloseMeetingPopup();
    // Add all other popups you need to close.
  }

  //** Standard Notification Popup **//
  private popupSubject = new BehaviorSubject<PopupModel | null>(null);

  notification$ = this.popupSubject.asObservable();

  private resolvePopupPromise?: (popupReturn: PopupModelReturn) => void;

  ShowPopup(popupModel: PopupModel): Promise<PopupModelReturn> {
    this.CloseAllPopups();
    this.popupSubject.next(popupModel);

    return new Promise<PopupModelReturn>((resolve) => {
      this.resolvePopupPromise = resolve;
    });
  }
  ResolvePopup(popupReturn: PopupModelReturn) {
    if (this.resolvePopupPromise) {
      this.resolvePopupPromise(popupReturn);
    }
    this.ClosePopup();
  }

  ClosePopup() {
    this.popupSubject.next(null);
  }
  //** Email Popup **//
  private emailPopupSubject = new BehaviorSubject<EmailPopupModel | null>(null);

  emailNotification$ = this.emailPopupSubject.asObservable();

  private resolveEmailPopupPromise?: (popupReturn: PopupModelReturn) => void;

  ShowEmailPopup(emailPopupModel: EmailPopupModel): Promise<PopupModelReturn> {
    this.CloseAllPopups();
    this.emailPopupSubject.next(emailPopupModel);

    return new Promise<PopupModelReturn>((resolve) => {
      this.resolveEmailPopupPromise = resolve;
    });
  }
  ResolveEmailPopup(popupReturn: PopupModelReturn) {
    if (this.resolveEmailPopupPromise) {
      this.resolveEmailPopupPromise(popupReturn);
    }
    this.CloseEmailPopup();
  }
  CloseEmailPopup() {
    this.emailPopupSubject.next(null);
  }

  //// Setup Popups
  //** Services Setup Popup **//
  private servicePopupSubject = new BehaviorSubject<PopupSetupModel | null>(null);

  serviceNotification$ = this.servicePopupSubject.asObservable();

  private resolveServicePopupPromise?: (popupReturn: PopupModelReturn) => void;


  ShowServicePopup(popupSetupModel: PopupSetupModel): Promise<PopupModelReturn> {
    this.CloseAllPopups();
    this.servicePopupSubject.next(popupSetupModel);

    return new Promise<PopupModelReturn>((resolve) => {
      this.resolveServicePopupPromise = resolve;
    });
  }
  ResolveServicePopup(popupReturn: PopupModelReturn) {
    if (this.resolveServicePopupPromise) {
      this.resolveServicePopupPromise(popupReturn);
    }
    this.CloseServicePopup();
  }

  CloseServicePopup() {
    this.servicePopupSubject.next(null);
  }

  //** Patient Setup Popup **//
  private patientPopupSubject = new BehaviorSubject<PopupSetupModel | null>(null);

  patientNotification$ = this.patientPopupSubject.asObservable();

  private resolvePatientPopupPromise?: (popupReturn: PopupModelReturn) => void;


  ShowPatientSetupPopup(popupSetupModel: PopupSetupModel): Promise<PopupModelReturn> {
    this.CloseAllPopups();
    this.patientPopupSubject.next(popupSetupModel);

    return new Promise<PopupModelReturn>((resolve) => {
      this.resolvePatientPopupPromise = resolve;
    });
  }
  ResolvePatientPopup(popupReturn: PopupModelReturn) {
    if (this.resolvePatientPopupPromise) {
      this.resolvePatientPopupPromise(popupReturn);
    }
    this.ClosePatientPopup();
  }

  ClosePatientPopup() {
    this.patientPopupSubject.next(null);
  }

  private staffPopupSubject = new BehaviorSubject<PopupSetupModel | null>(null);

  staffNotification$ = this.staffPopupSubject.asObservable();

  private resolveStaffPopupPromise?: (popupReturn: PopupModelReturn) => void;

  //** Staff Setup Popup **//
  ShowStaffSetupPopup(popupSetupModel: PopupSetupModel): Promise<PopupModelReturn> {
    this.CloseAllPopups();
    this.staffPopupSubject.next(popupSetupModel);

    return new Promise<PopupModelReturn>((resolve) => {
      this.resolveStaffPopupPromise = resolve;
    });
  }
  ResolveStaffPopup(popupReturn: PopupModelReturn) {
    if (this.resolveStaffPopupPromise) {
      this.resolveStaffPopupPromise(popupReturn);
    }
    this.CloseStaffPopup();
  }

  CloseStaffPopup() {
    this.staffPopupSubject.next(null);
  }


  //// Scheduler Calendar Popups

  //** Appointment Setup popup **//
  private appointmentPopupSubject = new BehaviorSubject<PopupSetupModel | null>(null);

  appointmentNotification$ = this.appointmentPopupSubject.asObservable();

  private resolveAppointmentPopupPromise?: (popupReturn: PopupModelReturn) => void;
  ShowAppointmentPopup(popupSetupModel: PopupSetupModel): Promise<PopupModelReturn> {
    this.CloseAllPopups();
    this.appointmentPopupSubject.next(popupSetupModel);

    return new Promise<PopupModelReturn>((resolve) => {
      this.resolveAppointmentPopupPromise = resolve;
    });
  }

  ResolveAppointmentPopup(popupReturn: PopupModelReturn) {
    if (this.resolveAppointmentPopupPromise) {
      this.resolveAppointmentPopupPromise(popupReturn);
    }
    this.CloseAppointmentPopup();
  }

  CloseAppointmentPopup() {
    this.appointmentPopupSubject.next(null);
  }
  //** Appointment Checkout Popup **//
  private checkoutPopupSubject = new BehaviorSubject<PopupSetupModel | null>(null);

  checkoutNotification$ = this.checkoutPopupSubject.asObservable();

  private resolveCheckoutPopupPromise?: (popupReturn: PopupModelReturn) => void;

  ShowCheckoutPopup(popupSetupModel: PopupSetupModel): Promise<PopupModelReturn> {
    this.CloseAllPopups();
    this.checkoutPopupSubject.next(popupSetupModel);

    return new Promise<PopupModelReturn>((resolve) => {
      this.resolveCheckoutPopupPromise = resolve;
    });
  }
  ResolveCheckoutPopup(popupReturn: PopupModelReturn) {
    if (this.resolveCheckoutPopupPromise) {
      this.resolveCheckoutPopupPromise(popupReturn);
    }
    this.CloseCheckoutPopup();
  }

  CloseCheckoutPopup() {
    this.checkoutPopupSubject.next(null);
  }
  //** Administration & Leave Popup **//
  private administrationPopupSubject = new BehaviorSubject<PopupSetupModel | null>(null);

  administrationNotification$ = this.administrationPopupSubject.asObservable();

  private resolveAdministrationPopupPromise?: (popupReturn: PopupModelReturn) => void;

  ShowAdministrationPopup(popupSetupModel: PopupSetupModel): Promise<PopupModelReturn> {
    this.CloseAllPopups();
    this.administrationPopupSubject.next(popupSetupModel);

    return new Promise<PopupModelReturn>((resolve) => {
      this.resolveAdministrationPopupPromise = resolve;
    });
  }
  ResolveAdministrationPopup(popupReturn: PopupModelReturn) {
    if (this.resolveAdministrationPopupPromise) {
      this.resolveAdministrationPopupPromise(popupReturn);
    }
    this.CloseAdministrationPopup();
  }

  CloseAdministrationPopup() {
    this.administrationPopupSubject.next(null);
  }
  //** Meeting Setup **//
  private meetingPopupSubject = new BehaviorSubject<PopupSetupModel | null>(null);

  meetingNotification$ = this.meetingPopupSubject.asObservable();

  private resolveMeetingPopupPromise?: (popupReturn: PopupModelReturn) => void;
  ShowMeetingPopup(popupSetupModel: PopupSetupModel): Promise<PopupModelReturn> {
    this.CloseAllPopups();
    this.meetingPopupSubject.next(popupSetupModel);

    return new Promise<PopupModelReturn>((resolve) => {
      this.resolveMeetingPopupPromise = resolve;
    });
  }

  ResolveMeetingPopup(popupReturn: PopupModelReturn) {
    if (this.resolveMeetingPopupPromise) {
      this.resolveMeetingPopupPromise(popupReturn);
    }
    this.CloseMeetingPopup();
  }

  CloseMeetingPopup() {
    this.meetingPopupSubject.next(null);
  }

  public showNotifcation(messageType?: 'success' | 'error' | undefined, message?: string, button?: string, altButton?: string) {
    this.CloseAllPopups();
    if (messageType == undefined) {
      return;
    }
    let notificationPopup: PopupModel = new PopupModel();
    notificationPopup.Button = new PopupButton(button, button);
    notificationPopup.AltButton = new PopupButton(altButton, altButton);
    let result: PopupModelReturn = new PopupModelReturn();
    notificationPopup.Message = message;
    notificationPopup.MessageType = messageType;

    this.ShowPopup(notificationPopup).then((res: PopupModelReturn) => {
      if (res.Result == button)
      {
        result = res;
      }
      else
      {
        result = res;
      }
    });
  }
  //Scheduler Calendar Popup End
}
